import useSitePreference from '../hooks/use-site-preference'

const useSizeMappingData = () => {
    const {data: sizeData} = useSitePreference('productSizeMappingJSON')

    return sizeData?.productSizeMappingJSON
        ? JSON.parse(sizeData?.productSizeMappingJSON)?.size || {}
        : {}
}

export default useSizeMappingData
